import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { IndicativeService } from "@app/core/services/indicative.service";
import { MetaService } from "@app/core/services/meta.service";
import { UrlConfig } from "@app/core/utils";

@Component({
    selector: "app-android-partner-stores",
    templateUrl: "./android-partner-stores.component.html",
    styleUrl: "./android-partner-stores.component.scss",
    standalone: false,
})
export class AndroidPartnerStoresComponent implements OnInit, AfterViewInit {
    constructor(private indicativeService: IndicativeService, private metaService: MetaService, private router: Router) {}

    ngOnInit() {
        this.indicativeService.sendEvent("android_partner_stores_visited");
    }

    ngAfterViewInit() {
        this.metaService.setMetadata(
            this.metaService.generatePageMetaObject(
                "Android Partner Stores",
                "Aptoide Connect lets you tap into a vast network of partner app stores with just one integration, instantly expanding your app’s reach to over 250 million users worldwide.",
                UrlConfig.getURL(this.router.url),
                "",
                this.router.url
            )
        );
    }
}
